import { defineMessage } from 'services/localization';

export const messages = {
    popupTitle: defineMessage('mark_the_purchase_order_as_status'),
    buttonText: defineMessage('mark_as_status'),
    commentDescription: defineMessage('please_provide_a_commen_s_been_marked_as_status'),
    successToastText: defineMessage('purchase_order_has_been_marked_as_status'),
    errorToastText: defineMessage('failed_to_mark_purchase_order_as_status'),
};
